import { tv } from "@kirvanobr/theme";

export const styles = tv({
  slots: {
    base: "flex w-[4.5rem] h-[1.75rem] px-0 text-center justify-center items-center",
    text: "!text-inherit",
  },
  variants: {
    width: {
      fit: {
        base: ["w-[fit-content] px-3 py-1"],
      },
    },
  },
});
